import type {
  CompetitionId,
  CompetitionView,
  EventId,
  EventTypeView,
  EventView
} from '@ps/isp-web-services-types';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { EventTypeId } from '@swf/sports/types/eventType';
import { generateSportsPath } from '@swf/sports/utils/generateSportsPath';

export interface SportsEventRouteValues {
  eventTypeSlug?: string;
  eventTypeId?: EventTypeId;
  competitionSlug?: string;
  competitionId?: CompetitionId;
  eventSlug: string;
  eventId: EventId;
}

interface Props {
  event: EventView;
  eventType?: EventTypeView;
  competition?: CompetitionView;
}

export const useGenerateSportsEventUrl = ({ event, eventType, competition }: Props) => {
  const origin = useSelector(select.location.getOrigin);
  const baseUrl = useSelector(select.location.getBaseURL);
  const aliases = useSelector(select.cms.getAliases);

  const alias = aliases.sportsEvent;

  if (!origin || !alias || !competition || !eventType) {
    return;
  }

  const values: SportsEventRouteValues = {
    eventId: event.eventId,
    eventSlug: event.eventSlug,
    competitionId: competition.competitionId,
    competitionSlug: competition.competitionSlug,
    eventTypeId: eventType.eventTypeId,
    eventTypeSlug: eventType.eventTypeSlug
  };

  const path = generateSportsPath(
    alias,
    values as unknown as Record<string, string | number | boolean | undefined>
  );

  return `${origin}${baseUrl ?? ''}${path}`;
};
